import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import { sockets, mediasoupSockets } from '@/common/sockets';
import { setSentryUser } from '@/common/sentry';

export async function offApp() {
  store.commit('common/setHideToolbar', true);
  store.commit('common/setHideSidebar', true);
  const authRouters = ['Login', 'ForgotPassword', 'CheckEligibility', 'Register', 'ConfirmPassword', 'Confirmation'];
  if (!authRouters.includes(router.history.current.name)) await router.push({ name: 'Login' });

  sockets.close();
  mediasoupSockets.close();

  await clearBrowserServiceWorkers();
  clearDataAfterLogout();
}

async function clearBrowserServiceWorkers() {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      // eslint-disable-next-line no-await-in-loop
      await registration.unregister();
    }
  }
}

export function clearDataAfterLogout() {
  Vue.prototype.$clearTabSession();
  localStorage.removeItem('sessionId');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('token');
  sessionStorage.clear();
  store.dispatch('loggedAccount/clearSession');
  setSentryUser(null);
}
